import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
import { futurePrice, launchSpots, price } from '../data/copy';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Bloque de urgencia que se sitúa junto a la tarjeta de precio. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'ore'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  return <div className="rounded-3xl border border-accent/25 bg-accent-soft px-5 py-6 text-center sm:px-7" data-id="element-29" data-mp="15fh3c47lszcf">
      <p className="flex items-center justify-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-accent" data-id="element-30" data-mp="34pyzo9w8td29">
        <AlarmClockIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-31" data-mp="1c0ydu07brkub" />
        Offerta di lancio — prezzo limitato
      </p>

      {isExpired ? <p className="mt-4 font-serif text-2xl font-bold leading-snug text-ink" data-id="element-32" data-mp="1h1cprtc1rexm">
          L'offerta di lancio è terminata.
        </p> : <>
          <div className="mx-auto mt-5 grid max-w-sm grid-cols-3 gap-2 sm:gap-3" aria-hidden="true" data-id="element-33" data-mp="171lvnsref1y2">
            {units.map(unit => <div key={unit.label} className="flex flex-col items-center justify-center rounded-2xl border border-line bg-card px-2 py-3 text-center" data-id="element-34" data-mp="1uqmy8zdjvivf">
                <span className="block font-serif text-4xl font-bold leading-none text-ink sm:text-5xl" data-id="element-35" data-mp="1zsc6y8davkgc">
                  {pad(unit.value)}
                </span>
                <span className="mt-1.5 block font-sans text-[10px] font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-36" data-mp="1pzeo214ebth7">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-37" data-mp="2iibswmdugjfj">
            Mancano {hours} ore, {minutes} minuti e {seconds} secondi alla fine
            dell'offerta di lancio.
          </p>

          <div className="mt-6 border-t border-accent/15 pt-5" data-id="element-38" data-mp="2ndefmng40ph2">
            <div className="flex items-baseline justify-between gap-4 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-39" data-mp="2jc1a6egxioao">
              <span data-id="element-40" data-mp="2ec6mskwd4gud">Primi {launchSpots} posti a {price}</span>
              <span className="text-accent" data-id="element-41" data-mp="29dlmklh41x5x">Ne restano pochi</span>
            </div>
            <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-card" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Posti di lancio già presi" data-id="element-42" data-mp="24n560shztvfc">
              <div className="h-full rounded-full bg-accent" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-43" data-mp="1vmqjxqx7gcas" />
            </div>
            <p className="mt-2 text-right font-sans text-[11px] text-muted" data-id="element-44" data-mp="1qmuf5pgoogu6">
              {spotsTakenPercent}% dei posti presi
            </p>
            <p className="mt-4 font-sans text-[0.82rem] leading-relaxed text-muted" data-id="element-45" data-mp="168jfedie26k">
              Dopo il lancio, il prezzo salirà a{' '}
              <span className="font-semibold text-ink" data-id="element-46" data-mp="64a1bvz77vgg">{futurePrice}</span>.
            </p>
          </div>
        </>}
    </div>;
}